import { LoadCurveEntry } from '../../../../core/clients/omni-core/models';

export interface FileState {
  id: string;
  messageKey: string;
  messageParams?: Record<string, unknown>;
  file: File;

  createdAt: Date;
  finishedAt: Date | null;

  progress: number;
  error: Error | null;
  loadCurve: LoadCurveEntry[] | null;
}

export const parseFile = async (state: FileState): Promise<LoadCurveEntry[]> => {
  const content = await state.file.text();
  const lines = content.trim().split('\n');

  if (lines.length < 2) {
    throw new Error('File must contain a header row and at least one data row');
  }

  const headerLine = lines[0];
  const headers = parseCsvLine(headerLine).map((h) => h.trim().toLowerCase());

  const requiredHeaders = ['validfrom', 'validto', 'consumptioninkwh'];
  const missingHeaders = requiredHeaders.filter((h) => !headers.includes(h));
  if (missingHeaders.length > 0) {
    throw new Error(`Missing required headers: ${missingHeaders.join(', ')}`);
  }

  const validFromIndex = headers.indexOf('validfrom');
  const validToIndex = headers.indexOf('validto');
  const consumptionIndex = headers.indexOf('consumptioninkwh');

  return lines
    .slice(1)
    .map((line) => line.trim())
    .filter((line) => line.length > 0)
    .map((line, index) => {
      const values = parseCsvLine(line);
      const consumptionInKWh = parseFloat(values[consumptionIndex]);

      if (isNaN(consumptionInKWh)) {
        throw new Error(
          `Invalid consumption value at row ${index + 2}: ${values[consumptionIndex]}`,
        );
      }

      return {
        validFrom: values[validFromIndex].trim(),
        validTo: values[validToIndex].trim(),
        consumptionInKWh,
      };
    });
};

const parseCsvLine = (line: string): string[] => {
  const result: string[] = [];
  let current = '';
  let inQuotes = false;

  for (const char of line) {
    if (char === '"') {
      inQuotes = !inQuotes;
    } else if ((char === ',' || char === ';') && !inQuotes) {
      result.push(current);
      current = '';
    } else {
      current += char;
    }
  }

  result.push(current);
  return result;
};
